import { IWorkItem } from "@wingspanhq/payments/dist/interfaces";
import {
  IWorkItemCreateRequest,
  IWorkItemUpdateRequest
} from "@wingspanhq/payments/dist/interfaces/api/workItem";
import { WSService } from "../utils/WSService";

const service = new WSService("/payments/work-item");

export async function createWorkItem(
  request: IWorkItemCreateRequest
): Promise<IWorkItem> {
  const { data } = await service.post("", request);
  return data;
}

export type ApiQueryListWorkItems = {
  "filter[workLogId][=]"?: string;
  "filter[workDefinitionId][=]"?: string;
};

export async function listWorkItems(
  query?: ApiQueryListWorkItems
): Promise<IWorkItem[]> {
  const { data } = await service.get("", { params: query });
  return data;
}

export async function getWorkItem(workItemId: string): Promise<IWorkItem> {
  const { data } = await service.get(workItemId);
  return data;
}

export async function updateWorkItem(
  workItemId: string,
  request: IWorkItemUpdateRequest
): Promise<IWorkItem> {
  const { data } = await service.patch(workItemId, request);
  return data;
}

export async function deleteWorkItem(workItemId: string): Promise<void> {
  await service.delete(workItemId);
}
